const AVATAR_BG_COLORS =['#6e62ae', '#e27e74', '#0091ea', '#3d9ea0', '#ffc44c'] as const;

const avatarBackground = AVATAR_BG_COLORS[Math.floor(Math.random() * AVATAR_BG_COLORS.length)];
export { avatarBackground };
